<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Travel Requirement</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container margin_60_35">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <div class="header_box version_2">
                  <h3>
                    <i class="fa fa-phone"></i> Receive Quotation from merchant
                    When You Will Plan Tour & Travel.
                  </h3>
                </div>
                <form @submit.prevent="updateProfile()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="category">Occasion</label>
                            <select
                              name=""
                              class="form-control select2"
                              id="category"
                              v-model="event"
                            >
                              <option>-Select-</option>
                              <option value="birthday">BirthDay</option>
                              <option value="anniversary">Anniversary</option>
                              <option value="party">Party</option>
                              <option value="engagement">Engagement</option>
                              <option value="baby-shower">Baby-shower</option>
                              <option value="farewell">Farewell</option>
                              <option value="retirement">Retirement</option>
                              <option value="others">Others</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Event Date</label>
                            <date-picker
                              v-model="event_date"
                              :config="datepickerconfig"
                            ></date-picker>
                          </div>
                        </div>
                         <div class="col-md-4">
                          <div class="form-group">
                            <label>End Event Date</label>
                            <date-picker
                              v-model="event_end"
                              :config="datepickerconfig"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Requirement</label>
                            <ckeditor
                              :editor="editor"
                              v-model="description"
                              :config="editorConfig"
                            ></ckeditor>
                          </div>
                        </div>
                      </div>
                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <h5>Categories</h5>
                            <div
                              class="form-check category"
                              v-for="cat in categories"
                              :key="cat.id"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="cat.tag_id"
                                v-model="category_id"
                              />
                              <label class="form-check-label" for="">{{
                                cat.category
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                           <label>Location</label>
                          <input class="form-control" v-model="location"  />
                        </div>
                        <div class="col-lg-6">
                           <label>Pincode</label>
                          <input class="form-control" type="number"
                          v-model="pincode"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">
                           <label>Files</label>
                          <input class="form-control" type="file" :v-model="file"
                          />
                        </div>
                      </div>
                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <div id="pass-info" class="clearfix"></div>
                          <center><button
                            type="submit"
                            class="btn_1 rounded add_top_30"
                          >
                            Post Requirement
                          </button></center>
                        </div>
                      </div>
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      categories: [],
      category_id: [],
      msg: null,
      classAlert: null,
      profile_img: null,
      image: "",
      file: [],
      location:'',
      pincode:'',
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: true,
        minDate: new Date(),
      },
      description: "",
      event_end:'',
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        height: "500px",
      },
      event_date: "",
      event: "",
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
  beforeMount() {
    this.checkToken();

    this.getAreaofinterest();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
    getAreaofinterest() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);

      API.get("customer/category_by_customerId", {
        headers: { Authorization: token },    
      })
        .then((res) => {
          this.categories = res.data.data;
          res.data.data.forEach((value) => {
            this.category_id.push(value.tag_id);
          });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },

    updateProfile() {
      // alert(this.profileDetails.first_name);
      //alert(this.profileDetails.dob);
      const form = new FormData();
      form.append("category_id", this.category_id);
    
      form.append("location", this.location);
      form.append("pincode", this.pincode);
      form.append("event_date", this.event_date);
      form.append("event_end", this.event_end);
      form.append("description", this.description);
      form.append("event", this.event);
      if (this.file.length > 0) {
         form.append("file", this.file);
      }
      API.post("/profile/update", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.msg = "Your Profile updated Successfully";
            this.classAlert = "success";
            // router.push("/");
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          this.classAlert = "danger";
        });
      //axios
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.profile_img = files[0];
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.image = "";
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100px;
  height: 100px;
}
</style>